import { useMemo } from "react";

// Barra de filtros do dashboard: período (presets ou datas), comparar com anterior, conta, produto, campanha.
// O estado vive na página; aqui só UI.

export const PRESETS = [
    { key: "hoje", label: "Hoje", dias: 0 },
    { key: "ontem", label: "Ontem", dias: -1 },
    { key: "7d", label: "7 dias", dias: 7 },
    { key: "14d", label: "14 dias", dias: 14 },
    { key: "30d", label: "30 dias", dias: 30 },
    { key: "mes", label: "Este mês", dias: "mes" },
];

function toStr(d) { return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; }

export function periodoDoPreset(key) {
    const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
    const p = PRESETS.find(x => x.key === key) || PRESETS[2];
    if (p.dias === 0) return { start: toStr(hoje), end: toStr(hoje) };
    if (p.dias === -1) { const d = new Date(hoje); d.setDate(d.getDate() - 1); return { start: toStr(d), end: toStr(d) }; }
    if (p.dias === "mes") { const d = new Date(hoje.getFullYear(), hoje.getMonth(), 1); return { start: toStr(d), end: toStr(hoje) }; }
    const d = new Date(hoje); d.setDate(d.getDate() - (p.dias - 1)); return { start: toStr(d), end: toStr(hoje) };
}

const sel = "bg-surface-3 text-ink-1 px-2 py-1.5 rounded-lg text-xs max-w-[240px] truncate border border-white/[0.1] focus:border-brand-500 focus:outline-none";

export default function FiltrosGlobais({ filtros, onChange, opcoes }) {
    const campanhas = useMemo(() => {
        const lista = opcoes?.campanhas || [];
        return filtros.conta_id ? lista.filter(c => String(c.conta_id) === String(filtros.conta_id)) : lista;
    }, [opcoes, filtros.conta_id]);

    function setPreset(key) { onChange({ ...filtros, preset: key, ...periodoDoPreset(key) }); }
    function setData(k, v) { onChange({ ...filtros, preset: null, [k]: v }); }

    return (
        <div className="surface-card p-3 flex flex-wrap items-end gap-3">
            <div className="flex gap-1">
                {PRESETS.map(p => (
                    <button key={p.key} onClick={() => setPreset(p.key)}
                        className={`px-2.5 py-1.5 rounded-lg text-xs font-medium transition ${filtros.preset === p.key ? "bg-brand-500/25 text-brand-200 ring-1 ring-brand-500/40" : "bg-surface-3 text-ink-3 hover:text-ink-1"}`}>
                        {p.label}
                    </button>
                ))}
            </div>
            <div className="hidden sm:block w-px h-7 bg-white/[0.08]" />
            <div className="flex items-end gap-2">
                <div><label className="block text-[10px] text-ink-4 mb-0.5">Início</label><input type="date" value={filtros.start} onChange={e => setData("start", e.target.value)} className={sel} /></div>
                <div><label className="block text-[10px] text-ink-4 mb-0.5">Fim</label><input type="date" value={filtros.end} onChange={e => setData("end", e.target.value)} className={sel} /></div>
            </div>
            <label className="flex items-center gap-1.5 text-xs text-ink-3 cursor-pointer pb-2">
                <input type="checkbox" checked={!!filtros.compare} onChange={e => onChange({ ...filtros, compare: e.target.checked })} className="accent-brand-500" />
                Comparar com período anterior
            </label>
            <div className="hidden sm:block w-px h-7 bg-white/[0.08]" />
            <div>
                <label className="block text-[10px] text-ink-4 mb-0.5">Produto</label>
                <select value={filtros.produto_id || ""} onChange={e => onChange({ ...filtros, produto_id: e.target.value || null })} className={sel}>
                    <option value="">Todos</option>
                    {(opcoes?.produtos || []).map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
                </select>
            </div>
            <div>
                <label className="block text-[10px] text-ink-4 mb-0.5">Conta</label>
                <select value={filtros.conta_id || ""} onChange={e => onChange({ ...filtros, conta_id: e.target.value || null, campanha_id: null })} className={sel}>
                    <option value="">Todas</option>
                    {(opcoes?.contas || []).map(c => <option key={c.id} value={c.id}>{c.nome}{!c.ativo ? " (fora do BI)" : ""}</option>)}
                </select>
            </div>
            <div>
                <label className="block text-[10px] text-ink-4 mb-0.5">Campanha</label>
                <select value={filtros.campanha_id || ""} onChange={e => onChange({ ...filtros, campanha_id: e.target.value || null })} className={sel}>
                    <option value="">Todas</option>
                    {campanhas.map(c => <option key={c.id} value={c.id}>{c.efetivo_status === "ACTIVE" ? "● " : "○ "}{c.nome}</option>)}
                </select>
            </div>
        </div>
    );
}
